export enum AppraisalMeetingStatus {
  Draft = 0,
  InProgress = 1,
  PendingReview = 2,
  Completed = 3,
  Cancelled = 4
}
